import React, {Component} from "react";
import {
    Button,
    FormSection,
    Input,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionFooterSecondaryContent,
    SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import {STYLE_LINK} from "../Styles/style";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

export class RequireNewPasswordComponent extends Component {
    render() {
        return (
            <div>
            <Header/>
            <FormSection theme={this.props.theme}>
            <SectionHeader theme={this.props.theme}>{I18n.get("Change Password")}</SectionHeader>
            <SectionBody theme={this.props.theme}>
                <Input
                    placeholder={I18n.get("Old Passward")}
                    theme={this.props.theme}
                    key="old_password"
                    name="old_password"
                    type="password"
                    onChange={this.props.newRequestPassword.handleInputChange}
                />
                <Input
                    placeholder={I18n.get("New Password")}
                    theme={this.props.theme}
                    key="new_password"
                    name="new_password"
                    type="password"
                    onChange={this.props.newRequestPassword.handleInputChange}
                />
                <Input
                    placeholder={I18n.get("New Password Confirm")}
                    theme={this.props.theme}
                    key="new_password_confirm"
                    name="new_password_confirm"
                    type="password"
                    onChange={this.props.newRequestPassword.handleInputChange}
                />

                {this.props.map}

            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    <Button theme={this.props.theme} onClick={this.props.change}>
                        {I18n.get("Change")}
                    </Button>
                </SectionFooterPrimaryContent>
                <SectionFooterSecondaryContent theme={this.props.theme}>
                    <Link theme={this.props.theme}  style={STYLE_LINK} onClick={this.props.changeStateFunc}>
                        {I18n.get("Back to Sign In")}
                    </Link>
                </SectionFooterSecondaryContent>
            </SectionFooter>
        </FormSection>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

RequireNewPasswordComponent.propTypes = {
    theme: PropTypes.any,
    newRequestPassword: PropTypes.any,
    map: PropTypes.any,
    change: PropTypes.func,
    changeStateFunc: PropTypes.func
};